/* 商品カードのSPスワイプによる1枚目↔ホバー画像切替
 * 横50px以上のスワイプで切替・縦スクロールは維持・タップは商品詳細遷移
 */
(function () {
  var SWIPE_THRESHOLD = 50;

  function attach(card) {
    if (card.dataset.swipeAttached === 'true') return;
    if (!card.querySelector('.ss-card__img--hover')) return;
    card.dataset.swipeAttached = 'true';

    var startX = 0, startY = 0, deltaX = 0, deltaY = 0, swiped = false;

    card.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      deltaX = 0;
      deltaY = 0;
      swiped = false;
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      deltaX = t.clientX - startX;
      deltaY = t.clientY - startY;
    }, { passive: true });

    card.addEventListener('touchend', function () {
      if (Math.abs(deltaX) > SWIPE_THRESHOLD && Math.abs(deltaX) > Math.abs(deltaY)) {
        swiped = true;
        card.classList.toggle('ss-card--show-hover');
      }
    });

    card.addEventListener('click', function (e) {
      if (swiped) {
        e.preventDefault();
        e.stopPropagation();
        swiped = false;
      }
    });
  }

  function init() {
    var cards = document.querySelectorAll('.ss-card');
    for (var i = 0; i < cards.length; i++) attach(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 動的に挿入したカード（例：おすすめ商品のinnerHTML挿入後）へ再初期化できるよう公開
  window.SSCardSwipe = init;
})();
